import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { CampaignSharingLiveDisplay } from 'components/pages/campaign-settings/campaign-sharing/general/CampaignSharingLiveDisplay';
import { CampaignSharingQrCode } from 'components/pages/campaign-settings/campaign-sharing/general/CampaignSharingQrCode';
import { CampaignSharingSeo } from 'components/pages/campaign-settings/campaign-sharing/general/CampaignSharingSeo';
import { CampaignSharingSlug } from 'components/pages/campaign-settings/campaign-sharing/general/CampaignSharingSlug';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';

const CampaignSharingGeneralSettings = () => {
    const { data: campaign } = useCurrentCampaign();
    const isNotGeneral = campaign?.type !== 'general';

    return (
        <Box className={'flex flex-col gap-8 p-8'}>
            {isNotGeneral && <CampaignSharingSlug />}
            {campaign?.can_use_live_display && (
                <>
                    <Separator />
                    <CampaignSharingLiveDisplay />
                </>
            )}
            <Separator />
            <CampaignSharingQrCode />
            {isNotGeneral && (
                <>
                    <Separator />
                    <CampaignSharingSeo />
                </>
            )}
        </Box>
    );
};

export { CampaignSharingGeneralSettings };
